import { css, keyframes } from '@emotion/core'
import { LetterSpace, NavBottomPadding, TxtLimit, TxtLimit2 } from '@styles/base.style'
import { CheckBoxStyle } from '@styles/button.style'
import styled, { Theme } from '@themes/theme'

const GmoneyAni = keyframes`
    40%, 60% {
      color: #ea8902;
    }
    //25% {
    //  transform: rotateX(2deg) translateY(2px) rotate(-2deg) scale(1);
    //}
    //45% {
    //  transform: translateY(-4px) rotate(1deg) scale(1.1);
    //}
    25% {
      transform: scale(1);
    }
    45% {
      transform: scaleX(1.2) scaleY(1.1);
    }
`

export const ItemShopBgWrap = styled.div`
  z-index: 2;
  position: sticky;
  top: -116px;
  margin-bottom: -295px;
  left: 0;
  overflow: hidden;
  .item-shop-bg {
    position: relative;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    height: 300px;
  }
  .character {
    position: absolute;
    top: 6px;
    right: 0;
    width: auto;
    height: 290px;
  }
  &.pc {
    top: -155px;
  }
`
export const ItemShopTitInfoBtn = (theme:Theme) => css`
  z-index: 2;
  position:relative;
  background: none;
  display: block;
  height: auto;
  margin-top: 18px;
  padding-left: 40px;
  text-align: left;
  svg {
    width: 18px;
    margin-right: 4px;
    transform: translateY(9%);
  }
  &, span {
    font-size: ${theme.font.largeNum};
    font-weight: ${theme.fontW.medium};
    line-height: 2.2rem;
  }
  span {
    font-weight: ${theme.fontW.bold};
  }
`
export const UserMoneyInfoWrap = styled.div`
  z-index: 2;
  position: sticky;
  top: calc(40px + 15px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 80px);
  margin: 31px auto 14px;
  background: ${props=>props.theme.color.modalBg};
  border-radius: 10px;
  &.pc {
    top: 15px;
  }
  .money-info-gmoney, .money-info-other {
    margin: 14px 0;
    line-height: 2rem;
  }
  .money-num {
    position: relative;
    color: ${props=>props.theme.color.mainBg};
    ${TxtLimit};
    width: calc(100% - 18px);
    text-align: right;
    &.gmoney {
      span {
        ${TxtLimit};
      }
    }
  }
  .money-info-gmoney {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    width: 45%;
    height: 50px;
    padding: 0 3.6% 0 0;
    border-right: 1px solid ${props=>props.theme.color.modalDarkBg};
    &--top {
      display: block;
      font-size: ${props => props.theme.font.large};
      color: ${props => props.theme.color.modalSubTxt};
      text-align: center;
      text-indent: 12px;
      .charge-btn {
        padding: 5px 10px;
      }
    }
    &--bottom {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .money-num {
        //animation: ${GmoneyAni} .6s infinite ease-in-out;
        span {
          display:block;
          text-align: right;
          color: ${props=>props.theme.color.mainBg};
        }
        // &.active {
        //   animation: ${GmoneyAni} .6s 1 ease-in-out;
        // }
      }

    }
  }
  .money-info-other {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    width: 55%;
    height: 50px;
    padding: 0 14px 0 10px;
    &--list {
      display: flex;
      justify-content: space-between;
      color: ${props=>props.theme.color.modalSubTxt};
      .money-tip-btn {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        width: 42px;
        color: ${props => props.theme.color.modalSubTxt};
        background: none;
        &--ico {
          width: 14px;
          height: 14px;
          margin-left: 4px;
          background: ${props=>props.theme.color.themeTxt};
          border-radius: 50%;
          img {
            width: 5px;
            height: auto;
          }
        }
      }
      &--scash {
        display: flex;
        align-items: center;
        width: 60px;
        color: ${props=>props.theme.color.modalSubTxt};
        .charge-btn {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          transform: translateY(-1px);
          width: 31px;
          height: auto;
          margin-left: 2px;
          img {
            width: 100%;
            height: auto;
            transform: translate3d(0, 0, 0);
          }
        }
      }
      &--value {
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        color: ${props=>props.theme.color.mainBg};
        &.scash {
          width: calc(100% - 60px);
        }
        &.heart {
          width: calc(100% - 42px);
        }
      }
    }
  }
  svg {
    width: 14px;
    margin-left: 4px;
  }
`
export const ItemList = (theme:Theme) => css`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 300px;
  padding: 12px;
  background: ${theme.color.modalBg};
  border-radius: 0 0 10px 10px;
  li {
    width: calc(50% - 6px);
    height: 187px;
    margin-bottom: 12px;
  }
`
export const ItemButton = styled.button`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: unset;
  width: 100%;
  height: 100%;
  padding: 0;
  background: ${props => props.theme.color.themeTxt};
  box-shadow: none;
  border: none;
  border-radius: 12px;
  overflow: hidden;

  .item-value {
    display:flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.color.mainBg};
    font-size: ${props => props.theme.font.largeNum};
    padding: 10px;
    &.item {
      font-size: ${props => props.theme.font.large};
    }
  }
  .money-img {
    width: 128px;
    height: auto;
    margin: -15px auto -3px;
  }
  .item-img {
    width: auto;
    height: 100px;
    margin: 0 auto 12px;
  }
  .item-skin {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    max-height: 36px;
    min-height: 36px;
    margin: 7px 21px;
    background: ${props => props.theme.color.modalBg};
    border-radius: 3px;
    &--plus {
      width: 15px;
      height: 15px;
      margin-right: 3px;
    }
    &--img {
      width: 44px;
      margin: -10px 0 0;
    }
    &--name {
      text-align: left;
      color: ${props => props.theme.color.mainBg};
    }
  }

  .item-price {
    display:flex;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.color.secondaryBg};
    padding: 5px 10px;
    color: ${props => props.theme.color.themeTxt};
    font-size: ${props => props.theme.font.largeNum};
    text-indent: 10px;
  }
  // 재화 표시 아이콘
  svg {
    width: 18px;
    margin-left: 3px;
    transform: translateY(-2%);
  }

  // 닉네임 변경 모달
  &.modal {
    position: relative;
    width: 136px;
    height: 108px;
    margin: 0 auto;
    padding: 0;
    &::before {
      height: 76px;
    }
  }
`
export const DummyWrap = styled.span`
  z-index: 2;
  position: relative;
  top: -12px;
  width: auto;
  height: 84px;
  display: block;
  margin: 1px auto;
  &.modal-dummy {
    top: 0;
    height: 76px;
  }
`
export const DummyStyle = css`
  height: 90px;
  &.modal {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: inherit;
    transform: translate(-50%, -48%);
  }
`
export const ItemName = styled.span`
  z-index: 2;
  position: relative;
  height: 26px;
  display: block;
  top: -3px;
  font-size: ${props => props.theme.font.small};
  margin: 0;
  line-height: 1.2rem;
  color: ${props => props.theme.color.themeTxt};
  .money {
    top: 1px;
  }
  &.modal-name {
    width: 100%;
    height: 24px;
    top: 0;
    font-size: ${props => props.theme.font.medium};
    .name {
      position: absolute;
      left: 50%;
      top: 50%;
      display: inline-block;
      width: 85%;
      ${TxtLimit2};
      transform: translate(-50%, -50%);
    }
  }
  &.modal {
    height: auto;
    margin: 8px auto;
    top: 0;
    font-size: ${props => props.theme.font.medium};
    color: ${props => props.theme.color.gray};
    .money {
      top: 1px;
      width: 10px;
      margin-left: 4px;
    }
  }
`
export const MoneyWrap = styled.span`
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 140px;
  height: 24px;
  line-height: 2.4rem;
  transform: translate(-50%, 0);
  font-size: ${props => props.theme.font.large};
  .money {
    width: 14px;
  }
`
export const Content = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex: 1;
`
export const ContentWrapStyle = (theme: Theme) => css`
  padding: 8px 17px;
  background: ${theme.color.TP};
  box-shadow: none;
  &.user-money-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 0px;
  }
`
export const Wrapper = styled.div`
  position: relative;
  width: calc(50% - 15px);
  height: auto;
  margin-bottom: 6px;
  &.s-cash {
    position: relative;
    width: 40%;
  }
`
export const ContentTitleStyle = (theme: Theme) => css`
  width: 100%;
  padding-bottom: 0;
  color: ${theme.color.gray};
  font-size: ${theme.font.small};
  &::after {
    display: none;
  }
  .s-cash-txt {
    display: none;
  }
`
export const ChargeButtonStyle = (theme: Theme) =>
  css`
    top: 50%;
    width: 64px;
    height: 22px;
    margin-left: -8%;
    line-height: 2.2rem;
    font-size: ${theme.font.small};
    transform: translateY(-50%);
  `
export const ButtonWrap = styled.div`
  position: relative;
  width: 100%;
  padding: 0 20px 14px;
  text-align: left;
`
export const CancelButtonStyle = css`
  position: relative;
  left: 0;
  width: calc(50% - 7px);
  margin-right: 14px;
`
export const ScashButtonStyle = css`
  float: right;
  min-width: 80px;
  width: calc(50% - 7px);
  margin-left: 0 !important;
  padding: 3px 0;
`
export const ItemWrapStlye = css`
  width: 100%;
  margin: 4px !important;
`
export const ItemStlye = css`
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 4px 4px !important;
`
export const Num = styled.span`
  position: relative;
  top: -1px;
  float: right;
  max-width: calc(100% - 55px);
`
export const Wrap = styled.div`
  position: relative;
  width: 100%;
  display: block;
  margin: 0 auto;
  text-align: left;
  &.item-img {
    text-align: center;
  }
  &:not(.item-img) {
    background: ${props => props.theme.color.contentsBg};
  }
  .row {
    height: 30px;
    line-height: 2rem;
    padding: 6px 14px;
    border-bottom: 1px solid ${props => props.theme.color.mainBg};
    &.top {
      height: 40px;
      line-height: 3rem;
    }
    &.notice {
      height: 42vh;
      .notice-txt {
        ${LetterSpace};
        margin: 6px 0 12px;
        line-height: 1.4rem;
      }
    }
  }
  .col {
    &.text-right {
      text-align: right;
      .money {
        top: 3px;
        width: 14px;
      }
    }
    &:not(.text-right) {
      color: ${props => props.theme.color.gray};
    }
  }
  ${CheckBoxStyle};
`
export const IcoStyle = styled.span`
  display: inline-block;
  position: relative;
  top: 2px;
  right: 0;
  width: 10px;
  &.user-money {
    float: right;
    top: 0;
    margin-left: 4px;
  }
`
export const ItemListWrapper = styled.div`
  display: block;
  width: auto;
  margin: 0 10px 40px;
  padding-bottom: ${NavBottomPadding};
`
